import { Link } from 'react-router-dom';
import { Product } from '../../../../types/catalog';
import { selectImage } from '../../../../util/misc';

export default function ProductItem({ url, etim, name, article, imageVariants, imageUrl }: Product) {
    const imgUrl = selectImage(imageVariants, 200, 50, imageUrl);

    return (
        <table className="iek-prodcat-catalog-section-item">
            <tbody>
                <tr className="tr-responsive-photo">
                    <td style={{ width: '75px', textAlign: 'center' }} className="td-photo">
                        <Link to={url} style={{ display: 'block' }}>
                            {imgUrl && (
                                <img
                                    src={imgUrl}
                                    alt={name}
                                    title={name}
                                    style={{
                                        maxWidth: '60px',
                                        maxHeight: '90px',
                                    }}
                                />
                            )}
                        </Link>
                    </td>
                </tr>
                <tr className="tr-common-card">
                    <td style={{ width: '75px', textAlign: 'center' }} className="td-photo">
                        <Link to={url} style={{ display: 'block' }}>
                            {imgUrl && (
                                <img
                                    src={imgUrl}
                                    alt={name}
                                    title={name}
                                    style={{
                                        maxWidth: '60px',
                                        maxHeight: '90px',
                                    }}
                                />
                            )}
                        </Link>
                    </td>

                    <td>
                        <div className="iek-prodcat-catalog-section-item__name">
                            <Link to={url}>{name}</Link>
                        </div>

                        <div className="iek-prodcat-catalog-section-item__article">Артикул: {article}</div>

                        <table className="iek-prodcat-catalog-section-item-features">
                            <tbody>
                                {etim?.features?.slice(0, 4).map((f, idx) => (
                                    <tr key={idx}>
                                        <td className="name">
                                            <span className="iek-prodcat-catalog-section-item-features__name">
                                                {f.name}:
                                            </span>
                                        </td>
                                        <td className="iek-prodcat-catalog-section-item-features__value-cell">
                                            {f.value}
                                            <span className="iek-prodcat-catalog-section-item-features__unit-name">
                                                {f.unit}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
